import type { ScoutToolPart } from "./message/scoutChatMessage";

export const SCOUT_ENCAMP_REPRESENTATIVE_TOOL_NAME = "present_encamp_representative";

export type EncampRepresentative = {
  cardId: string;
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

function readString(value: Record<string, unknown>, key: string): string | undefined {
  const candidate = value[key];
  return typeof candidate === "string" ? candidate : undefined;
}

export function parseEncampRepresentative(output: unknown): EncampRepresentative | null {
  if (!isRecord(output)) return null;
  if (output.kind !== "encamp_representative") return null;
  const cardId = readString(output, "cardId");
  if (!cardId) return null;
  return { cardId };
}

export function isScoutEncampRepresentativeTool(toolPart: ScoutToolPart): boolean {
  return toolPart.toolName === SCOUT_ENCAMP_REPRESENTATIVE_TOOL_NAME;
}
